import React from 'react';
import "./Footer.scss";


const Footer = (props) => {
    
    let msgFooter = `VOICE is intended for INTERNAL USE ONLY. VOICE contains North America and EMEA E1 data only.`

    return (
     <div className="custom-footer">
     { props.location.pathname==="/dashboard" && <span className="footerDesc">{`${msgFooter}`}</span>}
    </div>
        
    
      );
};
export default Footer;